import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { Subscription } from 'rxjs';
import { Permission } from '../../../models/permission.model';
import { AccountService } from '../../../services/account.service';
import { fadeInOut } from '../../../services/animations';
import { CoalService } from '../../../services/coal.service';
import { ConfigurationService } from '../../../services/configuration.service';
import { ContractBaseService } from '../../../services/contract-base.service';
import { CoTwoService } from '../../../services/cotwo.service';
import { CustomersService } from '../../../services/customers.service';
import { ElectricityContractService } from '../../../services/electricity-contract.service';
import { ElectricityService } from '../../../services/electricity.service';
import { GasContractService } from '../../../services/gas-contract.service';
import { GasService } from '../../../services/gas.service';
import { GasTwoService } from '../../../services/gatwo.service';
import { OilService } from '../../../services/oil.service';
import { BelpexService } from '../../../services/belpex.service';
import * as moment from 'moment';
import { GasThreeService } from '../../../services/gasthree.service';
let _ = require('lodash');
require('chart.js');

@Component({
    selector: 'dashboard',
    template: require('./dashboard.component.html'),
    styles: [require('./dashboard.component.css')],
    animations: [fadeInOut]
})
export class DashboardComponent implements OnDestroy {
    private subscribers: Subscription[] = [];

    electricityLastUpdate: any;
    gasLastUpdate: any;
    oilLastUpdate: any;
    coalLastUpdate: any;
    cotwoLastUpdate: any;
    gastwoLastUpdate: any;
    gasthreeLastUpdate: any;

    gasttfoneLastUpdate: any;
    gastfttwoLastUpdate: any;

    belpexLastUpdate: any;

    contractsCount: number = 0;
    customersCount: number = 0;

    isloadingoilLastUpdate: boolean = false;
    isloadingcoalLastUpdate: boolean = false;
    isloadingcotwoLastUpdate: boolean = false;
    isloadinggastwoLastUpdate: boolean = false;
    isloadinggasthreeLastUpdate: boolean = false;
    isLoadingloadingcontractsCount: boolean = false;
    isLoadingloadingcustomersCount: boolean = false;
    isloadingbelpexLastUpdate: boolean = false;


    gasStatistics: any;
    oilStatistics: any;
    coalStatistics: any;
    cotwoStatistics: any;
    electricityStatistics: any;
    gastwoStatistics: any;
    belpexStatistics: any;

    gasttfStatistics: any;  
    gastwoStatisticsttf: any;


    gasCount: number;
    oilCount: number;
    coalCount: number;
    cotwoCount: number;
    electricityCount: number;
    gastwoCount: number;
    BelpexCount: number;

    suggestedMin: number = 10;
    suggestedMax: number = 20;

    MinGas: number = 10;
    MaxGas: number = 20;
    MinOil: number = 10;
    MaxOil: number = 20;
    MinCoal: number = 10;
    MaxCoal: number = 20;
    MinElectricity: number = 10;
    MaxElectricity: number = 20;
    MinCotwo: number = 10;
    MaxCotwo: number = 20;
    MinGastwo: number = 10;
    MaxGastwo: number = 20;
    MinBelpex: number = 10;
    MaxBelpex: number = 20;

    MinGasttf: number = 10;
    MaxGasttf: number = 20;

    chartDataGas: Array<any> = [];
    chartLabelsGas: Array<any> = [];
    chartOptionsGas: any;

    chartDataElectricity: Array<any> = [];
    chartLabelsElectricity: Array<any> = [];
    chartOptionsElectricity: any;

    chartDataGastwo: Array<any> = [];
    chartLabelsGastwo: Array<any> = [];
    chartOptionsGastwo: any;

    chartDataCotwo: Array<any> = [];
    chartLabelsCotwo: Array<any> = [];
    chartOptionsCotwo: any;

    chartDataCoal: Array<any> = [];
    chartLabelsCoal: Array<any> = [];
    chartOptionsCoal: any;

    chartDataOil: Array<any> = [];
    chartLabelsOil: Array<any> = [];
    chartOptionsOil: any;

    chartDataBelpex: Array<any> = [];
    chartLabelsBelpex: Array<any> = [];
    chartOptionsBelpex: any;

    GetResult: any;
   
    gasttfdataStatisticsData: any
    chartColors: Array<any> = [
        {
            // Light red
            backgroundColor: 'rgba(255, 99, 132, 0.2)',
            borderColor: 'rgba(255, 99, 132, 1)',
            pointBackgroundColor: 'rgba(255, 99, 132, 1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(255, 99, 132, 0.8)'
        },
        {
            // Bright blue
            backgroundColor: 'rgba(54, 162, 235, 0.2)',
            borderColor: 'rgba(54, 162, 235, 1)',
            pointBackgroundColor: 'rgba(54, 162, 235, 1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(54, 162, 235, 0.8)'
        },
        {
            // Light orange
            backgroundColor: 'rgba(255, 206, 86, 0.2)',
            borderColor: 'rgba(255, 206, 86, 1)',
            pointBackgroundColor: 'rgba(255, 206, 86, 1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(255, 206, 86, 1)'
        },
        {
            // Moderate cyan
            backgroundColor: 'rgba(75, 192, 192, 0.2)',
            borderColor: 'rgba(75, 192, 192, 1)',
            pointBackgroundColor: 'rgba(75, 192, 192, 1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(75, 192, 192,0.8)'
        }
    ];

    chartLegend: boolean = true;

    chartType: string = 'line';
    loading: boolean = false;

    constructor(private accountService: AccountService, private electricityService: ElectricityService, private gasService: GasService,
        private oilService: OilService, private coalService: CoalService,
        private cotwoService: CoTwoService, private gastwoService: GasTwoService,
        private gasthreeService: GasThreeService,
        private belpexService: BelpexService,
        public configurations: ConfigurationService,
        private electricityContractService: ElectricityContractService, private gasContractService: GasContractService,
        private customersService: CustomersService, private router: Router, private ngxLogger: NGXLogger, private contractBaseService: ContractBaseService) {
    }

    ngOnInit() {

        this.isloadingbelpexLastUpdate = this.isloadinggastwoLastUpdate = this.isloadinggasthreeLastUpdate= this.isloadingcotwoLastUpdate = this.isloadingcoalLastUpdate = this.isloadingoilLastUpdate = this.isLoadingloadingcontractsCount = this.isLoadingloadingcustomersCount = true;

        const getBelpexUPSubscriber = this.belpexService.getLastUpdateDate().subscribe(res => {
            this.belpexLastUpdate = res;
        }, error => {
            this.ngxLogger.error(error.message);
            throw error;
            });

        const getELUPSubscriber = this.electricityService.getLastUpdateDate().subscribe(res => {
            this.electricityLastUpdate = res;
        }, error => {
            this.ngxLogger.error(error.message);
            throw error;
        });

        this.subscribers.push(getELUPSubscriber);

        const getGasUPSubscriber = this.gasService.getLastUpdateDate().subscribe(res => {

            this.gasLastUpdate = res;
        }, error => {
            this.ngxLogger.error(error.message);
            throw error;
        });
        this.subscribers.push(getGasUPSubscriber);

        const getoilUPSubscriber = this.oilService.getLastUpdateDate().subscribe(res => {

            this.oilLastUpdate = res;
            this.isloadingoilLastUpdate = false;
        }, error => {
            this.isloadingoilLastUpdate = false;
            this.ngxLogger.error(error.message);
            throw error;
        });
        this.subscribers.push(getoilUPSubscriber);

        const getcoalUPSubscriber = this.coalService.getLastUpdateDate().subscribe(res => {

            this.coalLastUpdate = res;
            this.isloadingcoalLastUpdate = false;
        }, error => {
            this.isloadingcoalLastUpdate = false;
            this.ngxLogger.error(error.message);
            throw error;
        });
        this.subscribers.push(getcoalUPSubscriber);

        const getcotwoUPSubscriber = this.cotwoService.getLastUpdateDate().subscribe(res => {
            this.cotwoLastUpdate = res;
            this.isloadingcotwoLastUpdate = false;
        }, error => {
            this.isloadingcotwoLastUpdate = false;
            this.ngxLogger.error(error.message);
            throw error;
        });
        this.subscribers.push(getcotwoUPSubscriber);

        const getGasTwoUPSubscriber = this.gastwoService.getLastUpdateDate().subscribe(res => {

            this.gastwoLastUpdate = res;
            this.isloadinggastwoLastUpdate = false;
        }, error => {
            this.isloadinggastwoLastUpdate = false;
            this.ngxLogger.error(error.message);
            throw error;
        });
        this.subscribers.push(getGasTwoUPSubscriber);

        const getGasThreeUPSubscriber = this.gasthreeService.getLastUpdateDate().subscribe(res => {

            this.gasthreeLastUpdate = res;
            this.isloadinggasthreeLastUpdate = false;
        }, error => {
            this.isloadinggasthreeLastUpdate = false;
            this.ngxLogger.error(error.message);
            throw error;
        });
        this.subscribers.push(getGasThreeUPSubscriber);

        const getCountSubscriber = this.contractBaseService.getCount().subscribe((res: number) => {
            this.contractsCount = res;
            this.isLoadingloadingcontractsCount = false;
        }, error => {
            this.isLoadingloadingcontractsCount = false;
            this.ngxLogger.error(error.message);
        });
        this.subscribers.push(getCountSubscriber);

        const getCustCountSubscriber = this.customersService.getCount().subscribe((res: number) => {
            this.customersCount = res;
            this.isLoadingloadingcustomersCount = false;
        }, error => {
            this.isLoadingloadingcustomersCount = false;
            this.ngxLogger.error(error.message);
            throw error;
        });
        this.subscribers.push(getCustCountSubscriber);

        this.loading = true;
        const gasStaSubscriber = this.gasService.getAllResultStatistics(12).subscribe(res => {
            this.GetResult = res;            

            let tempgas = _(this.GetResult.gas)
                .map((value, key) => ({ Data: value.SettlementPrice }))
                .value();

            let tempoil = _(this.GetResult.oil)
                .map((value, key) => ({ Data: value.SettlementPrice }))
                .value();

            let tempcoal = _(this.GetResult.coal)
                .map((value, key) => ({ Data: value.SettlementPrice }))
                .value();

            let tempcotwo = _(this.GetResult.cotwo)
                .map((value, key) => ({ Data: value.SettlementPrice }))
                .value();

            let tempelectricity = _(this.GetResult.electricity)
                .map((value, key) => ({ Data: value.SettlementPrice }))
                .value();            

            this.gasttfdataStatisticsData = this.GetResult.gastwo.concat(this.GetResult.gasthree);

            this.gastwoStatisticsttf = _(this.gasttfdataStatisticsData).groupBy(x => x.StripName)
                .map((value, key) => ({ StripName: key, Data: value }))
                .value();    

            this.GetResult.gasthree.forEach((obj) => {
                let existNotification = this.GetResult.gastwo.find(({ Datum }) => obj.Datum === Datum);                
                if (!existNotification) {  
                    const newObj = { ...obj };
                    newObj.SettlementPrice = 0;
                    newObj.StripName = 'Gas TTF 101';
                    this.GetResult.gastwo.push({ ...newObj });
                }
            }); 

            this.GetResult.gastwo.forEach((obj) => {
                let existNotification = this.GetResult.gasthree.find(({ Datum }) => obj.Datum === Datum);
                if (!existNotification) {
                    const newObj = { ...obj };
                    newObj.SettlementPrice = 0;
                    newObj.StripName = 'Gas TTF 103';
                    this.GetResult.gasthree.push({ ...newObj });
                }
            });             

            let gasttf = this.GetResult.gastwo.concat(this.GetResult.gasthree);

            let tempgastwo = _(gasttf)
                .map((value, key) => ({ Data: value.SettlementPrice }))
                .value();

            let tempbelpex = _(this.GetResult.belpex)
                .map((value, key) => ({ Data: value.SettlementPrice }))
                .value();

            this.MaxGas = Math.max.apply(Math, tempgas.map(function (o) { return o.Data; }));
            this.MinGas = Math.min.apply(Math, tempgas.map(function (o) { return o.Data; }));

            this.MaxOil = Math.max.apply(Math, tempoil.map(function (o) { return o.Data; }));
            this.MinOil = Math.min.apply(Math, tempoil.map(function (o) { return o.Data; }));

            this.MaxCoal = Math.max.apply(Math, tempcoal.map(function (o) { return o.Data; }));
            this.MinCoal = Math.min.apply(Math, tempcoal.map(function (o) { return o.Data; }));

            this.MaxCotwo = Math.max.apply(Math, tempcotwo.map(function (o) { return o.Data; }));
            this.MinCotwo = Math.min.apply(Math, tempcotwo.map(function (o) { return o.Data; }));

            let minFilterelectricity = tempelectricity.filter(gc => gc.Data != 0 && gc.Data != null);
            this.MaxElectricity = Math.max.apply(Math, tempelectricity.map(function (o) { return o.Data; }));
            this.MinElectricity = Math.min.apply(Math, minFilterelectricity.map(function (o) { return o.Data; }));
            
            let minFilterGastwo = tempgastwo.filter(gc => gc.Data != null);
            this.MaxGastwo = Math.max.apply(Math, tempgastwo.map(function (o) { return o.Data; }));
            this.MinGastwo = Math.min.apply(Math, minFilterGastwo.map(function (o) { return o.Data; }));

            this.MaxBelpex = Math.max.apply(Math, tempbelpex.map(function (o) { return o.Data; }));
            this.MinBelpex = Math.min.apply(Math, tempbelpex.map(function (o) { return o.Data; }));

            this.gasStatistics = _(this.GetResult.gas).groupBy(x => x.StripName)
                .map((value, key) => ({ StripName: key, Data: value }))
                .value();

            this.oilStatistics = _(this.GetResult.oil).groupBy(x => x.StripName.substring(3, x.StripName.length))
                .map((value, key) => ({ StripName: key, Data: value }))
                .value();

            this.coalStatistics = _(this.GetResult.coal).groupBy(x => x.StripName)
                .map((value, key) => ({ StripName: key, Data: value }))
                .value();

            this.cotwoStatistics = _(this.GetResult.cotwo).groupBy(x => x.StripName.substring(3, x.StripName.length))
                .map((value, key) => ({ StripName: key, Data: value }))
                .value();

            this.electricityStatistics = _(this.GetResult.electricity).groupBy(x => x.StripName)
                .map((value, key) => ({ StripName: key, Data: value }))
                .value();

            
            this.gasttfStatistics = this.GetResult.gastwo.concat(this.GetResult.gasthree);

            
            this.gastwoStatistics = _(this.gasttfStatistics).groupBy(x => x.StripName)
                .map((value, key) => ({ StripName: key, Data: value }))
                .value();          

            this.belpexStatistics = _(this.GetResult.belpex).groupBy(x => x.StripName)
                .map((value, key) => ({ StripName: key, Data: value }))
                .value(); 
           

            let numbersGas = this.gasStatistics.map(i => i.Data.length);
            this.gasCount = numbersGas.reduce((a, b) => a + b, 0);

            let numbersOil = this.oilStatistics.map(i => i.Data.length);
            this.oilCount = numbersOil.reduce((a, b) => a + b, 0);

            let numbersCoal = this.coalStatistics.map(i => i.Data.length);
            this.coalCount = numbersCoal.reduce((a, b) => a + b, 0);

            let numbersCotwo = this.cotwoStatistics.map(i => i.Data.length);
            this.cotwoCount = numbersCotwo.reduce((a, b) => a + b, 0);

            let numberselectricity = this.electricityStatistics.map(i => i.Data.length);
            this.electricityCount = numberselectricity.reduce((a, b) => a + b, 0);
            
            let numbersGastwo = this.gastwoStatisticsttf.map(i => i.Data.length);
            this.gastwoCount = numbersGastwo.reduce((a, b) => a + b, 0);

            let numbersBelpex = this.belpexStatistics.map(i => i.Data.length);
            this.BelpexCount = numbersBelpex.reduce((a, b) => a + b, 0);

            this.refreshGasChart();
            this.refreshOilChart();
            this.refreshCoalChart();
            this.refreshCotwoChart();
            this.refreshelectricityChart();
            this.refreshGastwoChart();
            this.refreshBelpexChart();

            this.loading = false;
        }, error => {
            this.loading = false;
            this.ngxLogger.error(error.message);
            throw error;
        });

        this.subscribers.push(gasStaSubscriber);

    }

    refreshGasChart(): void {
        if (this.gasStatistics != null && this.gasStatistics !== undefined && this.gasStatistics.length > 0) {
            let _chartData: Array<any> = [{ data: new Array(this.gasStatistics.length) }];
            let _chartLabels: Array<any> = new Array(this.gasStatistics[0].Data.length);
            
            _chartLabels = _.map(this.gasStatistics[0].Data, 'Datum');
            for (let i = 0; i < this.gasStatistics.length; i++) {
                _chartData[i] = { data: new Array(this.gasStatistics[i].Data.length), label: this.gasStatistics[i].StripName };
                for (let j = 0; j < this.gasStatistics[i].Data.length; j++) {
                    _chartData[i].data[j] = this.gasStatistics[i].Data[j].SettlementPrice;
                }
            }

            this.chartDataGas = _chartData;
            this.chartLabelsGas = _chartLabels;

            this.chartOptionsGas = {
                responsive: true,
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            suggestedMin: this.suggestedMin,
                            suggestedMax: this.suggestedMax,
                            min: this.MinGas,
                            max: this.MaxGas
                        }
                    }]
                },
                elements: {
                    line: {
                        fill: false
                    },
                    point: {
                        radius: 0
                    }
                }
            };
        }
    }

    refreshOilChart(): void {
        if (this.oilStatistics != null && this.oilStatistics !== undefined && this.oilStatistics.length > 0) {
            let _chartData: Array<any> = [{ data: new Array(this.oilStatistics.length) }];
            let _chartLabels: Array<any> = new Array(this.oilStatistics[0].Data.length);
            _chartLabels = _.map(this.oilStatistics[0].Data, 'Datum');
            for (let i = 0; i < this.oilStatistics.length; i++) {
                _chartData[i] = { data: new Array(this.oilStatistics[i].Data.length), label: "Cal " + this.oilStatistics[i].StripName };
                for (let j = 0; j < this.oilStatistics[i].Data.length; j++) {
                    _chartData[i].data[j] = this.oilStatistics[i].Data[j].SettlementPrice;
                }
            }

            this.chartDataOil = _chartData;
            this.chartLabelsOil = _chartLabels;

            this.chartOptionsOil = {
                responsive: true,
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            suggestedMin: this.suggestedMin,
                            suggestedMax: this.suggestedMax,
                            min: this.MinOil,
                            max: this.MaxOil
                        }
                    }]
                },
                elements: {
                    line: {
                        fill: false
                    },
                    point: {
                        radius: 0
                    }
                }
            };
        }
    }

    refreshCoalChart(): void {

        if (this.coalStatistics != null && this.coalStatistics !== undefined && this.coalStatistics.length > 0) {
            let _chartData: Array<any> = [{ data: new Array(this.coalStatistics.length) }];
            let _chartLabels: Array<any> = new Array(this.coalStatistics[0].Data.length);
            _chartLabels = _.map(this.coalStatistics[0].Data, 'Datum');
            for (let i = 0; i < this.coalStatistics.length; i++) {
                _chartData[i] = { data: new Array(this.coalStatistics[i].Data.length), label: this.coalStatistics[i].StripName };
                for (let j = 0; j < this.coalStatistics[i].Data.length; j++) {
                    _chartData[i].data[j] = this.coalStatistics[i].Data[j].SettlementPrice;
                }
            }

            this.chartDataCoal = _chartData;
            this.chartLabelsCoal = _chartLabels;

            this.chartOptionsCoal = {
                responsive: true,
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            suggestedMin: this.suggestedMin,
                            suggestedMax: this.suggestedMax,
                            min: this.MinCoal,
                            max: this.MaxCoal
                        }
                    }]
                },
                elements: {
                    line: {
                        fill: false
                    },
                    point: {
                        radius: 0
                    }
                }
            };
        }
    }

    refreshCotwoChart(): void {

        if (this.cotwoStatistics != null && this.cotwoStatistics !== undefined && this.cotwoStatistics.length > 0) {
            let _chartData: Array<any> = [{ data: new Array(this.cotwoStatistics.length) }];
            let _chartLabels: Array<any> = new Array(this.cotwoStatistics[0].Data.length);
            _chartLabels = _.map(this.cotwoStatistics[0].Data, 'Datum');
            for (let i = 0; i < this.cotwoStatistics.length; i++) {
                _chartData[i] = { data: new Array(this.cotwoStatistics[i].Data.length), label: "Cal " + this.cotwoStatistics[i].StripName };
                for (let j = 0; j < this.cotwoStatistics[i].Data.length; j++) {
                    _chartData[i].data[j] = this.cotwoStatistics[i].Data[j].SettlementPrice;
                }
            }

            this.chartDataCotwo = _chartData;
            this.chartLabelsCotwo = _chartLabels;

            this.chartOptionsCotwo = {
                responsive: true,
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            suggestedMin: this.suggestedMin,
                            suggestedMax: this.suggestedMax,
                            min: this.MinCotwo,
                            max: this.MaxCotwo
                        }
                    }]
                },
                elements: {
                    line: {
                        fill: false
                    },
                    point: {
                        radius: 0
                    }
                }
            };
        }
    }

    refreshelectricityChart(): void {
        if (this.electricityStatistics != null && this.electricityStatistics !== undefined && this.electricityStatistics.length > 0) {
            let _chartData: Array<any> = [{ data: new Array(this.electricityStatistics.length) }];
            let _chartLabels: Array<any> = new Array(this.electricityStatistics[0].Data.length);
            _chartLabels = _.map(this.electricityStatistics[0].Data, 'Datum');
            for (let i = 0; i < this.electricityStatistics.length; i++) {
                _chartData[i] = { data: new Array(this.electricityStatistics[i].Data.length), label: this.electricityStatistics[i].StripName };
                for (let j = 0; j < this.electricityStatistics[i].Data.length; j++) {
                    _chartData[i].data[j] = this.electricityStatistics[i].Data[j].SettlementPrice;
                }
            }

            this.chartDataElectricity = _chartData;
            this.chartLabelsElectricity = _chartLabels;

            this.chartOptionsElectricity = {
                responsive: true,
                scales: {
                    yAxes: [{
                        ticks: {
                            //beginAtZero: true,
                            suggestedMin: this.suggestedMin,
                            suggestedMax: this.suggestedMax,
                            min: this.MinElectricity,
                            max: this.MaxElectricity
                        }
                    }]
                },
                elements: {
                    line: {
                        fill: false
                    },
                    point: {
                        radius: 0
                    }
                }
            };
        }
    }

    refreshGastwoChart(): void {
        
        if (this.gastwoStatistics != null && this.gastwoStatistics !== undefined && this.gastwoStatistics.length > 0) {
            let _chartData: Array<any> = [{ data: new Array(this.gastwoStatistics.length) }];
            let _chartLabels: Array<any> = new Array(this.gastwoStatistics[0].Data.length);
            if (this.gastwoStatistics[1] != undefined) {
                _chartLabels = _.map(this.gastwoStatistics[0].Data.concat(this.gastwoStatistics[1].Data), 'Datum');
            }
            else {
                _chartLabels = _.map(this.gastwoStatistics[0].Data, 'Datum');
            }
            var unique = _chartLabels.filter(function (elem, index, self) {
                return index === self.indexOf(elem);
            });

            unique.sort((itemA, itemB) => {
                let mthAstr = itemA.slice(0, 3) + " 01 " + itemA.slice(3, 5);
                let mthA = new Date(mthAstr);
                let mthBstr = itemB.slice(0, 3) + " 01 " + itemB.slice(3, 5);
                let mthB = new Date(mthBstr);
                if (mthA < mthB)
                    return -1;
                if (mthA > mthB)
                    return 1;
                return 0;
            });            
            
            this.gastwoStatistics[0].Data = _.orderBy(this.gastwoStatistics[0].Data, [(user) => (unique.indexOf(user.Datum))], ["asc", "asc"]);
            this.gastwoStatistics[1].Data = _.orderBy(this.gastwoStatistics[1].Data, [(user) => (unique.indexOf(user.Datum))], ["asc", "asc"]);
                          
            for (let i = 0; i < this.gastwoStatistics.length; i++) {                
                _chartData[i] = { data: new Array(this.gastwoStatistics[i].Data.length), label: this.gastwoStatistics[i].StripName };
                for (let j = 0; j < this.gastwoStatistics[i].Data.length; j++) {
                    _chartData[i].data[j] = this.gastwoStatistics[i].Data[j].SettlementPrice;
                }
            }
            this.chartDataGastwo = _chartData;
            this.chartLabelsGastwo = unique;
            this.chartOptionsGastwo = {
                responsive: true,
                scales: {
                    yAxes: [{
                        ticks: {
                            //beginAtZero: true,
                            suggestedMin: this.suggestedMin,
                            suggestedMax: this.suggestedMax,
                            min: this.MinGastwo,
                            max: this.MaxGastwo
                        }
                    }]
                },
                elements: {
                    line: {
                        fill: false
                    },
                    point: {
                        radius: 0
                    }
                }
            };
        }
    }

    refreshBelpexChart(): void {        
        if (this.belpexStatistics != null && this.belpexStatistics !== undefined && this.belpexStatistics.length > 0) {
            let _chartData: Array<any> = [{ data: new Array(this.belpexStatistics.length) }];
            let _chartLabels: Array<any> = new Array(this.belpexStatistics[0].Data.length);
            _chartLabels = _.map(this.belpexStatistics[0].Data, 'Datum');
            for (let i = 0; i < this.belpexStatistics.length; i++) {
                _chartData[i] = { data: new Array(this.belpexStatistics[i].Data.length), label: this.belpexStatistics[i].StripName };
                for (let j = 0; j < this.belpexStatistics[i].Data.length; j++) {
                    _chartData[i].data[j] = this.belpexStatistics[i].Data[j].SettlementPrice;
                }
            }

            this.chartDataBelpex = _chartData;
            this.chartLabelsBelpex = _chartLabels;

            this.chartOptionsBelpex = {
                responsive: true,
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            suggestedMin: this.suggestedMin,
                            suggestedMax: this.suggestedMax,
                            min: this.MinBelpex,
                            max: this.MaxBelpex + 10
                        }
                    }]
                },
                elements: {
                    line: {
                        fill: false
                    },
                    point: {
                        radius: 0
                    }
                }
            };
        }
    }

    ngOnDestroy() {
        if (this.subscribers) {
            this.subscribers.forEach(s => s.unsubscribe());
        }
    }

    navigateElectricityOverview() {
        this.router.navigate(['electricity']);
    }

    navigateGasOverview() {
        this.router.navigate(['gas']);
    }

    navigateCoalOverview() {
        this.router.navigate(['coal']);
    }

    navigateOilOverview() {
        this.router.navigate(['oil']);
    }

    navigateCoTwoOverview() {
        this.router.navigate(['cotwo']);
    }

    navigateGasTwoOverview() {
        this.router.navigate(['gastwo']);
    }

    navigateGasThreeOverview() {
        this.router.navigate(['gasthree']);
    }

    navigateCustomerOverview() {
        this.router.navigate(['customers']);
    }

    navigateBelpexOverview() {
        this.router.navigate(['belpex']);
    }

    get canmanageDashboardPermission() {
        return this.accountService.userHasPermission(Permission.manageDashboardPermission);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/home/dashboard/dashboard.component.ts